// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__button___jJQIV {
}

.styles__buttonDanger___Y9BEB {
  margin-right: 20px;
}

.styles__buttonLink___Ygg_J {
  margin-right: 20px;
  padding: 1rem auto;
}

.styles__buttons___gLMqf {
  display: flex;
  margin-top: 2rem;
  justify-content: space-between;
}

.styles__buttonsLeft___lr7ct {
  justify-content: left;
}

.styles__buttonsRight___LTRok {
  justify-content: right;
}

.styles__cardMarginBot___FTypF {
  margin-top: 1rem;
}

.styles__errorWrapper___XTVKT {
}

.styles__form___nvQmT {
}

.styles__formItemMono___n9QCX {
}

.styles__input___TDf9a {
}

.styles__infoText___tJrP8 {
}

.styles__label___gSHKo {
}

.styles__sectionNoMargin___G63_H {
  display: flex;
}

.styles__sectionTitle___fjQEE {
}

.styles__sectionSmall___UZdQV {
}

.styles__textareaWrapper___T7k1o {
  width: 100%;
}
.styles__rejectionWrapper___g2IDN {
  border: 1px solid rgba(73, 80, 84, 0.15);
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(58, 64, 68, 0.08);
}

.styles__textarea___m6t4S {
  background-color: white;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  border-radius: 3px;
  max-width: 100%;
  padding: 7px 0.75rem;
  width: 100%;
}

.styles__textarea___m6t4S::placeholder {
    opacity: 0.5;
  }

.styles__textarea___m6t4S:focus {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
    border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
    outline: none;
  }

.styles__warningLabelGroup___z6nna {
  margin-top: 20px;
  margin-bottom: 10px;
}

.styles__warningLabelGroup___z6nna input {
  margin: 0 10px 20px 4px;
  top: 2px;
  position: relative;
}

.styles__warningLabel___K6eNM {
  color: red;
  font-weight: bold;
}

.styles__section___nt5of {
  padding-top: 1.25rem;
}
.styles__resolutionHeader___OEwXV {
  padding-top: 1.25rem;
  margin-bottom: 0;
}

.styles__feeSchedule___qSd8Q {
  width: calc(99.9% * 6/12 - (30px - 30px * 6/12));
}

.styles__feeSchedule___qSd8Q:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__feeSchedule___qSd8Q:last-child {
  margin-right: 0;
}

.styles__feeSchedule___qSd8Q:nth-child(12n) {
  margin-right: 0;
  float: right;
}

.styles__feeSchedule___qSd8Q:nth-child(12n + 1) {
  clear: both;
}
.styles__feeScheduleRight___RxW82 {
  width: calc(99.9% * 6/12 - (30px - 30px * 6/12));
}
.styles__feeScheduleRight___RxW82:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}
.styles__feeScheduleRight___RxW82:last-child {
  margin-right: 0;
}
.styles__feeScheduleRight___RxW82:nth-child(12n) {
  margin-right: 0;
  float: right;
}
.styles__feeScheduleRight___RxW82:nth-child(12n + 1) {
  clear: both;
}

.styles__depositCols___SKyMY {
  padding: 0 1rem;
  margin-right: 0 !important;
  /* lost-column: 1/2; */
}

.styles__depositCols___SKyMY .styles__depositLabel___QGHLh {
    font-weight: bold;
    margin-bottom: 0.4rem !important;
  }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F {
    margin: 0.25rem 0 0.5rem 0 !important;
    padding-bottom: 1rem;
  }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__rate___TO4Va {
      width: calc(99.9% * 1/10 - (30px - 30px * 1/10));
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__rate___TO4Va:nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__rate___TO4Va:last-child {
      margin-right: 0;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__rate___TO4Va:nth-child(10n) {
      margin-right: 0;
      float: right;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__rate___TO4Va:nth-child(10n + 1) {
      clear: both;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__formula___ElSm7 {
      width: calc(99.9% * 6/10 - (30px - 30px * 6/10));
      line-height: 1.5;
      font-weight: 500;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__formula___ElSm7:nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__formula___ElSm7:last-child {
      margin-right: 0;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__formula___ElSm7:nth-child(10n) {
      margin-right: 0;
      float: right;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__formula___ElSm7:nth-child(10n + 1) {
      clear: both;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__description___Kf3Uv {
      width: calc(99.9% * 3/10 - (30px - 30px * 3/10));
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__description___Kf3Uv:nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__description___Kf3Uv:last-child {
      margin-right: 0;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__description___Kf3Uv:nth-child(10n) {
      margin-right: 0;
      float: right;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__description___Kf3Uv:nth-child(10n + 1) {
      clear: both;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__descriptionFull___Hpufx {
      width: calc(99.9% * 9/10 - (30px - 30px * 9/10));
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__descriptionFull___Hpufx:nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__descriptionFull___Hpufx:last-child {
      margin-right: 0;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__descriptionFull___Hpufx:nth-child(10n) {
      margin-right: 0;
      float: right;
    }

.styles__depositCols___SKyMY .styles__depositValue___zHD9F .styles__descriptionFull___Hpufx:nth-child(10n + 1) {
      clear: both;
    }

.styles__alignRight___PDv79 {
  text-align: right;
}

.styles__cardMarginBotWrapperBottom___BB2yJ {
  padding-bottom: 0rem;
  background-color: white;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.styles__header___LRKE1 {
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayMid"]};
  display: flex;
  width: 100%;
}

.styles__header___LRKE1 p {
    font-weight: 600 !important;
    margin-bottom: 4px;
  }
.styles__depositIcon___b2KxX {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-left: 2.5rem;
}
.styles__depositIcon___b2KxX:hover {
    cursor: pointer;
  }

.styles__deposit___rVS0v,
.styles__depositIcon___b2KxX {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  opacity: 0.7;
}
.styles__date___HahNm {
  width: 4%;
  padding-right: 1rem;
  color: black;
  text-align: right !important;
}
.styles__appliedFee___h0c92 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  opacity: 0.7;
  text-align: right !important;
}
.styles__type___lyPyG {
  padding-left: 1rem;
}
.styles__rate___TO4Va {
  text-align: right !important;
}
.styles__amount___ZafUw {
  text-align: right !important;
  padding-right: 1.5rem;
}
.styles__adminFee___sjWoC {
  text-align: right !important;
}

.styles__refund___dOsIq {
  padding-top: 1rem;
  padding-right: 0.9rem;
  margin: 0 !important;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenDark"]};
  text-align: right;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
}

.styles__policyInfo___KXaAP {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
}

.styles__ticketCreation___WeVkR {
  font-style: italic;
}

.styles__depositTable___MMsCM {

  margin-left: 1rem;
  margin-right: 1rem;
}

.styles__depositTable___MMsCM > .styles__depositTableHead___TmETr {
    border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayMid"]};
  }

.styles__depositTable___MMsCM > .styles__depositTableHead___TmETr th {
      padding-bottom: 0.5rem;
      text-align: left;
    }

.styles__depositTable___MMsCM > .styles__depositTableHead___TmETr th:last-child {
        text-align: right !important;
      }

.styles__depositTable___MMsCM > .styles__depositTableHead___TmETr p {
      font-weight: 600 !important;
      margin-bottom: 4px;
    }

.styles__depositTable___MMsCM > .styles__depositTableBody___aUe7R tr td:last-child {
        text-align: right !important;
      }

.styles__rejectionNotes___GJT5G .styles__sectionTitle___fjQEE {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
    color: white;
    font-size: 1rem;
    height: 3rem;
    margin-bottom: 0 !important;
  }

.styles__rejectionNotes___GJT5G .styles__sectionNoMargin___G63_H {
    border-left: 2px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
    border-radius: 0 !important;
  }
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Tickets/Deposit/styles.css"],"names":[],"mappings":"AAIA;AAEA;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EAEE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,aAAa;AACf;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,8DAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,WAAW;AAWb;;AATE;IACE,YAAY;EACd;;AAEA;IACE,wDAAuB;IACvB,8DAAwB;IACxB,aAAa;EACf;;AAGF;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gDAAiB;AACnB;;AAFA;EACE,WAAiB;EAAjB,kBAAiB;EAAjB,WAAiB;AACnB;;AAFA;EACE,eAAiB;AACnB;;AAFA;EACE,eAAiB;EAAjB,YAAiB;AACnB;;AAFA;EACE,WAAiB;AACnB;AACA;EACE,gDAAiB;AACnB;AAFA;EACE,WAAiB;EAAjB,kBAAiB;EAAjB,WAAiB;AACnB;AAFA;EACE,eAAiB;AACnB;AAFA;EACE,eAAiB;EAAjB,YAAiB;AACnB;AAFA;EACE,WAAiB;AACnB;;AAEA;EAEE,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;AAuBxB;;AAtBE;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;AACA;IACE,qCAAqC;IACrC,oBAAoB;EAetB;;AAdE;MACE,gDAAiB;IACnB;;AAFA;MACE,WAAiB;MAAjB,kBAAiB;MAAjB,WAAiB;IACnB;;AAFA;MACE,eAAiB;IACnB;;AAFA;MACE,eAAiB;MAAjB,YAAiB;IACnB;;AAFA;MACE,WAAiB;IACnB;;AACA;MACE,gDAAiB;MACjB,gBAAgB;MAChB,gBAAgB;IAClB;;AAJA;MACE,WAAiB;MAAjB,kBAAiB;MAAjB,WAAiB;IAGnB;;AAJA;MACE,eAAiB;IAGnB;;AAJA;MACE,eAAiB;MAAjB,YAAiB;IAGnB;;AAJA;MACE,WAAiB;IAGnB;;AACA;MACE,gDAAiB;IACnB;;AAFA;MACE,WAAiB;MAAjB,kBAAiB;MAAjB,WAAiB;IACnB;;AAFA;MACE,eAAiB;IACnB;;AAFA;MACE,eAAiB;MAAjB,YAAiB;IACnB;;AAFA;MACE,WAAiB;IACnB;;AACA;MACE,gDAAiB;IACnB;;AAFA;MACE,WAAiB;MAAjB,kBAAiB;MAAjB,WAAiB;IACnB;;AAFA;MACE,eAAiB;IACnB;;AAFA;MACE,eAAiB;MAAjB,YAAiB;IACnB;;AAFA;MACE,WAAiB;IACnB;;AAIJ;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qEAAkC;EAClC,aAAa;EACb,WAAW;AAMb;;AAJE;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;AAEF;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;AAKtB;AAHE;IACE,eAAe;EACjB;;AAGF;;EAEE,mDAAiB;EACjB,YAAY;AACd;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,mDAAiB;EACjB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,mDAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAGE,iBAAiB;EACjB,kBAAkB;AAwBpB;;AAvBE;IACE,qEAAkC;EAapC;;AAZE;MACE,sBAAsB;MACtB,gBAAgB;IAIlB;;AAHE;QACE,4BAA4B;MAC9B;;AAGF;MACE,2BAA2B;MAC3B,kBAAkB;IACpB;;AAKE;QACE,4BAA4B;MAC9B;;AAMJ;IACE,8DAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,2BAA2B;EAC7B;;AACA;IACE,mEAAgC;IAChC,2BAA2B;EAC7B","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtBlue, gtBlueLight, gtGray, gtGrayMid, gtGrayDark, gtGreenDark, gtRedDark from colors;\n\n.button {\n  composes: button from helpers;\n}\n\n.buttonDanger {\n  composes: buttonDanger from helpers;\n  margin-right: 20px;\n}\n\n.buttonLink {\n  composes: button from helpers;\n  margin-right: 20px;\n  padding: 1rem auto;\n}\n\n.buttons {\n  composes: buttons from helpers;\n  display: flex;\n  margin-top: 2rem;\n  justify-content: space-between;\n}\n\n.buttonsLeft {\n  justify-content: left;\n}\n\n.buttonsRight {\n  justify-content: right;\n}\n\n.cardMarginBot {\n  composes: cardMarginBot from helpers;\n  margin-top: 1rem;\n}\n\n.errorWrapper {\n  composes: errorWrapper from helpers;\n}\n\n.form {\n  composes: form from helpers;\n}\n\n.formItemMono {\n  composes: formItemMono from helpers;\n}\n\n.input {\n  composes: input from helpers;\n}\n\n.infoText {\n  composes: infoText from helpers;\n}\n\n.label {\n  composes: label from helpers;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n  display: flex;\n}\n\n.sectionTitle {\n  composes: sectionTitle from helpers;\n}\n\n.sectionSmall {\n  composes: sectionSmall from helpers;\n}\n\n.textareaWrapper {\n  width: 100%;\n}\n.rejectionWrapper {\n  border: 1px solid rgba(73, 80, 84, 0.15);\n  border-radius: 4px;\n  box-shadow: 0 1px 2px 0 rgba(58, 64, 68, 0.08);\n}\n\n.textarea {\n  background-color: white;\n  border: 1px solid gtGray;\n  border-radius: 3px;\n  max-width: 100%;\n  padding: 7px 0.75rem;\n  width: 100%;\n\n  &::placeholder {\n    opacity: 0.5;\n  }\n\n  &:focus {\n    background: gtBlueLight;\n    border: 1px solid gtBlue;\n    outline: none;\n  }\n}\n\n.warningLabelGroup {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.warningLabelGroup input {\n  margin: 0 10px 20px 4px;\n  top: 2px;\n  position: relative;\n}\n\n.warningLabel {\n  color: red;\n  font-weight: bold;\n}\n\n.section {\n  padding-top: 1.25rem;\n}\n.resolutionHeader {\n  padding-top: 1.25rem;\n  margin-bottom: 0;\n}\n\n.feeSchedule {\n  lost-column: 6/12;\n}\n.feeScheduleRight {\n  lost-column: 6/12;\n}\n\n.depositCols {\n  composes: serif from helpers;\n  padding: 0 1rem;\n  margin-right: 0 !important;\n  /* lost-column: 1/2; */\n  .depositLabel {\n    font-weight: bold;\n    margin-bottom: 0.4rem !important;\n  }\n  .depositValue {\n    margin: 0.25rem 0 0.5rem 0 !important;\n    padding-bottom: 1rem;\n    .rate {\n      lost-column: 1/10;\n    }\n    .formula {\n      lost-column: 6/10;\n      line-height: 1.5;\n      font-weight: 500;\n    }\n    .description {\n      lost-column: 3/10;\n    }\n    .descriptionFull {\n      lost-column: 9/10;\n    }\n  }\n}\n\n.alignRight {\n  text-align: right;\n}\n\n.cardMarginBotWrapperBottom {\n  padding-bottom: 0rem;\n  background-color: white;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  border-bottom: 1px solid gtGrayMid;\n  display: flex;\n  width: 100%;\n  composes: serif from helpers;\n  p {\n    font-weight: 600 !important;\n    margin-bottom: 4px;\n  }\n}\n.depositIcon {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n  padding-left: 2.5rem;\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.deposit,\n.depositIcon {\n  color: gtGrayDark;\n  opacity: 0.7;\n}\n.date {\n  width: 4%;\n  padding-right: 1rem;\n  color: black;\n  text-align: right !important;\n}\n.appliedFee {\n  color: gtGrayDark;\n  opacity: 0.7;\n  text-align: right !important;\n}\n.type {\n  padding-left: 1rem;\n}\n.rate {\n  text-align: right !important;\n}\n.amount {\n  text-align: right !important;\n  padding-right: 1.5rem;\n}\n.adminFee {\n  text-align: right !important;\n}\n\n.refund {\n  padding-top: 1rem;\n  padding-right: 0.9rem;\n  margin: 0 !important;\n  color: gtGreenDark;\n  text-align: right;\n  width: 100%;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.policyInfo {\n  display: flex;\n  flex-direction: column;\n  margin-top: 1rem;\n}\n\n.ticketCreation {\n  font-style: italic;\n}\n\n.depositTable {\n  composes: serif from helpers;\n\n  margin-left: 1rem;\n  margin-right: 1rem;\n  & > .depositTableHead {\n    border-bottom: 1px solid gtGrayMid;\n    th {\n      padding-bottom: 0.5rem;\n      text-align: left;\n      &:last-child {\n        text-align: right !important;\n      }\n    }\n\n    p {\n      font-weight: 600 !important;\n      margin-bottom: 4px;\n    }\n  }\n\n  & > .depositTableBody {\n    tr {\n      td:last-child {\n        text-align: right !important;\n      }\n    }\n  }\n}\n\n.rejectionNotes {\n  .sectionTitle {\n    background-color: gtRedDark;\n    color: white;\n    font-size: 1rem;\n    height: 3rem;\n    margin-bottom: 0 !important;\n  }\n  .sectionNoMargin {\n    border-left: 2px solid gtRedDark;\n    border-radius: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGrayMid": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayMid"]}`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"gtGreenDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenDark"]}`,
	"gtRedDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]}`,
	"button": `styles__button___jJQIV ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"buttonDanger": `styles__buttonDanger___Y9BEB ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonDanger"]}`,
	"buttonLink": `styles__buttonLink___Ygg_J ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"buttons": `styles__buttons___gLMqf ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttons"]}`,
	"buttonsLeft": `styles__buttonsLeft___lr7ct`,
	"buttonsRight": `styles__buttonsRight___LTRok`,
	"cardMarginBot": `styles__cardMarginBot___FTypF ${___CSS_LOADER_ICSS_IMPORT_1___.locals["cardMarginBot"]}`,
	"errorWrapper": `styles__errorWrapper___XTVKT ${___CSS_LOADER_ICSS_IMPORT_1___.locals["errorWrapper"]}`,
	"form": `styles__form___nvQmT ${___CSS_LOADER_ICSS_IMPORT_1___.locals["form"]}`,
	"formItemMono": `styles__formItemMono___n9QCX ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemMono"]}`,
	"input": `styles__input___TDf9a ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"infoText": `styles__infoText___tJrP8 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["infoText"]}`,
	"label": `styles__label___gSHKo ${___CSS_LOADER_ICSS_IMPORT_1___.locals["label"]}`,
	"sectionNoMargin": `styles__sectionNoMargin___G63_H ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"sectionTitle": `styles__sectionTitle___fjQEE ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"sectionSmall": `styles__sectionSmall___UZdQV ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]}`,
	"textareaWrapper": `styles__textareaWrapper___T7k1o`,
	"rejectionWrapper": `styles__rejectionWrapper___g2IDN`,
	"textarea": `styles__textarea___m6t4S`,
	"warningLabelGroup": `styles__warningLabelGroup___z6nna`,
	"warningLabel": `styles__warningLabel___K6eNM`,
	"section": `styles__section___nt5of`,
	"resolutionHeader": `styles__resolutionHeader___OEwXV`,
	"feeSchedule": `styles__feeSchedule___qSd8Q`,
	"feeScheduleRight": `styles__feeScheduleRight___RxW82`,
	"depositCols": `styles__depositCols___SKyMY ${___CSS_LOADER_ICSS_IMPORT_1___.locals["serif"]}`,
	"depositLabel": `styles__depositLabel___QGHLh`,
	"depositValue": `styles__depositValue___zHD9F`,
	"rate": `styles__rate___TO4Va`,
	"formula": `styles__formula___ElSm7`,
	"description": `styles__description___Kf3Uv`,
	"descriptionFull": `styles__descriptionFull___Hpufx`,
	"alignRight": `styles__alignRight___PDv79`,
	"cardMarginBotWrapperBottom": `styles__cardMarginBotWrapperBottom___BB2yJ`,
	"header": `styles__header___LRKE1 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["serif"]}`,
	"depositIcon": `styles__depositIcon___b2KxX`,
	"deposit": `styles__deposit___rVS0v`,
	"date": `styles__date___HahNm`,
	"appliedFee": `styles__appliedFee___h0c92`,
	"type": `styles__type___lyPyG`,
	"amount": `styles__amount___ZafUw`,
	"adminFee": `styles__adminFee___sjWoC`,
	"refund": `styles__refund___dOsIq`,
	"policyInfo": `styles__policyInfo___KXaAP`,
	"ticketCreation": `styles__ticketCreation___WeVkR`,
	"depositTable": `styles__depositTable___MMsCM ${___CSS_LOADER_ICSS_IMPORT_1___.locals["serif"]}`,
	"depositTableHead": `styles__depositTableHead___TmETr`,
	"depositTableBody": `styles__depositTableBody___aUe7R`,
	"rejectionNotes": `styles__rejectionNotes___GJT5G`
};
export default ___CSS_LOADER_EXPORT___;
